module.exports = __webpack_public_path__ + "static/media/logo_block.12dc0969.png";